







































import Vue from 'vue'
import { sampleTexts } from '../utils/samples'

export default Vue.extend({
  name: 'WriteText',

  data() {
    const value = ''
    const sampleSrc = ''
    const disabledInput = true
    return {
      value,
      sampleSrc,
      disabledInput
    }
  },

  methods: {
    checkDisabledInput() {
      const textArea = this.$refs.textArea as any
      this.disabledInput =
        !textArea ||
        !textArea.internalValue ||
        textArea.internalValue?.trim().length === 0
    },
    addRandomText() {
      const sampleText =
        sampleTexts[Math.floor(Math.random() * sampleTexts.length)]
      ;(this.$refs.textArea as any).internalValue = sampleText.text
      this.sampleSrc = sampleText.src
    },
    getAnalysis() {
      if (this.$router.currentRoute.name === 'Analyse') {
        return
      }
      this.$router.push({
        name: 'Analyse',
        params: {
          textToAnalyse: (this.$refs.textArea as any).internalValue
        }
      })
    }
  }
})
